<template>
  <el-main class="userwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>店铺管理</el-breadcrumb-item>
        <el-breadcrumb-item>活动信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" :model="form" label-width="120px" label-position="left">
        <el-form-item label="" style="margin-left: -120px;">
          <el-col :span="4">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="活动名称" value="title"></el-option>
              <el-option label="店铺名" value="shop_name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" clearable>
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search" @keyup.enter.native="search">搜索</el-button>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="筛选">
          <el-col>
            <el-select v-model="form.shop_id" placeholder="选择" style="width: 100px;" @change="search">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-col>
        </el-form-item> -->

        <el-form-item label="已选条件：">
          <el-tag v-for="tag in tags" :key="tag.key" color="#003153" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>

      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="1">
            <el-checkbox label="活动名称"></el-checkbox>
            <el-checkbox label="所属门店"></el-checkbox>
            <el-checkbox label="活动类型"></el-checkbox>
            <el-checkbox label="奖品明细"></el-checkbox>
            <el-checkbox label="活动开始时间"></el-checkbox>
            <el-checkbox label="活动结束时间"></el-checkbox>
            <el-checkbox label="活动状态"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button icon="el-icon-plus" @click="addFn">新增</el-button>
        </div>
      </div>
      <el-table :data="tableData" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="title" label="活动名称" header-align="center" align="center" min-width="80" v-if="check('活动名称')"/>
        <el-table-column prop="shopName" label="所属门店" header-align="center" align="center" min-width="80" v-if="check('所属门店')">
          <template slot-scope="scope">
            {{ scope.row.shopArr ? scope.row.shopArr.name : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="activity_type" label="活动类型" header-align="center" align="center" min-width="60" v-if="check('活动类型')">
          <template slot-scope="scope">
            {{ dd.actiSens[scope.row.activity_type]}}
          </template>
        </el-table-column>
        <el-table-column prop="giftName" label="奖品明细" header-align="center" align="center" min-width="80" v-if="check('奖品明细')">
          <template slot-scope="scope">
            <div v-for="(gift, index) in scope.row.gifts" :key="`gift_${index}`">{{ gift.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="活动开始时间" header-align="center" align="center" min-width="60" v-if="check('活动开始时间')"/>
        <el-table-column prop="end_time" label="活动结束时间" header-align="center" align="center" min-width="60" v-if="check('活动结束时间')"/>
        <el-table-column prop="end_time" label="活动状态" header-align="center" align="center" min-width="60" v-if="check('活动状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.status_c[scope.row.is_over].color }">
              <div class="word">{{ dd.status_c[scope.row.is_over].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="操作" header-align="center" align="center" min-width="80" fixed="right">
          <template slot-scope="scope">
            <span class="link" style="cursor: pointer;" @click="handleDelete(scope.row)">删除</span>
            <span style="margin: 0 10px;">|</span>
            <span class="link" style="cursor: pointer;" @click="handleClick(scope.row)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
          :page-size="30" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>


<script>
import * as api from '@/api'
export default {
  name: 'User',
  data() {
    return {
      checkList: [
        '活动名称',
        '所属门店',
        '活动类型',
        '奖品明细',
        '活动开始时间',
        '活动结束时间',
        '活动状态',
      ],
      form: {
        key: '',
        atype: 'title',
      },
      tableData: [],
      perPage: 30,
      p: 1,
      total: 30,
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.actiType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
      ]

      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  mounted() {
    this.getActiList()
  },
  methods: {
    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },
    check(key) {
      return this.checkList.includes(key)
    },
    removeTag(tag) {
      if (tag.val === 'time') {
        this.form.time = ['', '']
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      this.getActiList()
    },
    search() {
      this.p = 1
      this.getActiList()
    },
    getActiList() {
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        [this.form.atype]: this.form.key,//搜索
      }
      api.getActiList(postData).then((res) => {
        this.tableData = res.resData.itemList
        this.total = Number(res.resData.totalNum)
      })
    },
    handleDelete(item) {
      this.$confirm('此操作将删除该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          api.updateActiInfo({ del_str: item.id }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.getActiList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleCurrentChange(p) {
      this.p = p
      this.getActiList()
    },
    handleClick(row) {
      // console.log(row)
      this.$router.push(`/acti/detail?id=${row.id}`)
    },
    addFn() {
      this.$router.push(`/acti/detail`)
    },
    handleSizeChange() {
      // console.log('sizechange')
    },
    onSubmit() {
      // console.log('submit!')
    },
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: $c;
}

.userwrap {
  .filterwrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 0 20px 0;

    .filter {
      width: 85%;
    }

    .btnarea {
      box-sizing: border-box;
      width: 15%;
      padding: 0 20px;
      display: flex;
      justify-content: flex-end;
    }
  }

  .el-checkbox-group.filtergroup .el-checkbox {
    width: auto;
  }

  .apage {
    background: #f2f2f2;
    padding: 8px;
    text-align: right;
  }

  .el-select {
    margin-right: 20px;
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
    height: 36px;
    line-height: 36px;
    border: none;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
  }

  .table {
    @extend %box;
    padding: 30px;
  }

  .line {
    text-align: center;
  }
}
</style>